import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import NotLoggedIn from '../pages/NotLoggedIn';
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  const publicPaths = ['/quality/barcodescanner', '/quality/inspectionpictures'];

  const isPublic = publicPaths.some((path) => pathname.includes(path));

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated && !isPublic) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    console.log('User is not authenticated, redirecting to login page');
    return <NotLoggedIn />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
